<template>
  <div class="about">
    <h1>This is an about page</h1>
    <button @click="rdTest()">RD Test</button>
  </div>
</template>

<script>
import AuthService from '@/components/Auth/AuthService'

const auth = new AuthService()
export default {
  computed: {

  },
  methods: {
    rdTest (val) {
      // how to add image card
      // console.log('Clicking Button')
      auth.login()
    }
  }

}
</script>
